jQuery(window).load(function() {
	
	if( jQuery( 'body' ).hasClass('page-template-template-home') ) {
	
	const iframe = document.querySelector('iframe');
	
    const player = new Vimeo.Player(iframe);

    player.on('play', function() {
	 
        jQuery('button.play').removeClass('paused');
		
		jQuery('button.play').addClass('playing');
		        
    });
    
    player.on('pause', function() {
	 
        jQuery('button.play').addClass('paused');
		
		jQuery('button.play').removeClass('playing');
		
        
    });

    player.getVideoTitle().then(function(title) {
	    
        console.log('title:', title);
        
    });
    
    }
    

});


jQuery('button.play').click(function(){
		
	if( jQuery( 'body' ).hasClass('page-template-template-home') ) {
		
	const iframe = document.querySelector('iframe');	
    const player = new Vimeo.Player(iframe);
		
	if( jQuery(this).hasClass('playing') ) {
		
		player.pause();
	
	}
	
	else {

		player.play();		
		
	}	
	
	}
					
});